import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

// Locale para o `Intl` — data, hora e moeda.
//
// `toLocaleString()` sem argumento usa o idioma do NAVEGADOR, não o da conta.
// Numa interface em português aberta num Chrome em inglês isso vira "R$50.00"
// e "8/14/2026, 10:52:48 AM". Aqui devolvemos o idioma escolhido no AstraChat,
// normalizado de `pt_BR` para `pt-BR` — o `Intl` recusa o underscore e estoura
// RangeError, que já derrubou tela nossa antes.
export function useAppLocale() {
  const { locale } = useI18n();
  const dtLocale = computed(() =>
    String(locale.value || 'en').replace('_', '-')
  );

  const formatDateTime = (iso, fallback = '—') =>
    iso ? new Date(iso).toLocaleString(dtLocale.value) : fallback;

  const formatDate = (iso, fallback = '—') =>
    iso ? new Date(iso).toLocaleDateString(dtLocale.value) : fallback;

  const formatTime = (date, fallback = '—') =>
    date ? new Date(date).toLocaleTimeString(dtLocale.value) : fallback;

  return { dtLocale, formatDateTime, formatDate, formatTime };
}
